<h2>Name: {{ orderSet.name }} </h2>

<h2>Provider Orders</h2>
<div class="table-container">
  <p-table #pot [value]="providerOrders()" styleClass="p-datatable" [rowHover]="true" responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="medName">
          <div class="flex justify-content-between align-items-center">
            Medication
            <p-sortIcon field="medName"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="dosage">
          <div class="flex justify-content-between align-items-center">
            Dosage
            <p-sortIcon field="dosage"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="route">
          <div class="flex justify-content-between align-items-center">
            Route
            <p-sortIcon field="route"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="type">
          <div class="flex justify-content-between align-items-center">
            Type
            <p-sortIcon field="type"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="administeredString">
          <div class="flex justify-content-between align-items-center">
            Administered
            <p-sortIcon field="administeredString"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-order>
      <tr class="p-selectable-row">
        <td>
          {{ order.medName }}
        </td>
        <td>
          {{ order.dosage }}
        </td>
        <td>
          {{ order.route }}
        </td>
        <td>
          {{ order.type }}
        </td>
        <td>
          {{ order.administeredString }}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No orders found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<h2>Nursing Orders</h2>
<div class="table-container">
  <p-table #not [value]="nursingOrders()" styleClass="p-datatable" [rowHover]="true" responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="simDateCreated">
          <div class="flex justify-content-between align-items-center">
            Date/Time
            <p-sortIcon field="simDateCreated"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="title">
          <div class="flex justify-content-between align-items-center">
            Title
            <p-sortIcon field="title"></p-sortIcon>
          </div>
        </th>
        <th pSortableColumn="signature">
          <div class="flex justify-content-between align-items-center">
            Signature
            <p-sortIcon field="signature"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-order>
      <tr class="p-selectable-row">
        <td>
          {{ order.datetimeString }}
        </td>
        <td>
          {{ order.title }}
        </td>
        <td>
          {{ order.signature }}
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8">No nursing orders found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<div class="footer">
  <button pButton pRipple type="button" class="close-button" (click)="closeDialog()">Close</button>
</div>